export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

export const BOOKMARK_CREATED = "BOOKMARK_CREATED";
export const GOT_URL_DATA = "GOT_URL_DATA";



// WEBPACK FOOTER //
// ./src/utils/types.js